import React, { useCallback } from 'react'

import { Select, SelectOption, SelectTitle } from 'ui/components/Select'

type ModelSelectRef = HTMLButtonElement

type ModelSelectProps = Omit<React.ComponentProps<typeof Select<false>>, 'onChange'> & {
    defaultModelLabel?: string
    onChange?: (value?: string) => void
}

export const ModelSelect = React.forwardRef<ModelSelectRef, ModelSelectProps>(function ModelSelect(
    { value, defaultModelLabel = 'Default model', onChange, ...props },
    ref
) {
    const handleChange = useCallback(
        (value: string) => {
            const newValue = value === 'default' ? undefined : value
            onChange?.(newValue)
        },
        [onChange]
    )

    return (
        <Select
            label="Model"
            shrink
            value={value || 'default'}
            size="m"
            onChange={handleChange}
            {...props}
            ref={ref}
        >
            <SelectOption value="default" label={defaultModelLabel} />
            <SelectOption value="gpt-4o" label="GPT-4o" />
            <SelectOption value="gpt-4o-mini" label="GPT-4o mini" />
            <SelectOption value="gpt-4.1" label="GPT-4.1" />
            <SelectOption value="gpt-4.1-mini" label="GPT-4.1 mini" />
            <SelectOption value="gpt-4.1-nano" label="GPT-4.1 nano" />
            <SelectTitle>Reasoning models</SelectTitle>
            <SelectOption value="o3" label="o3" />
            <SelectOption value="o3-mini" label="o3-mini" />
            <SelectOption value="o4-mini" label="o4-mini" />
        </Select>
    )
})
